// hooks/useResponsiveSplideOptions.js
import { useEffect, useState } from "react";

const useResponsiveSplideOptions = () => {
  const [splideOptions, setSplideOptions] = useState({});

  useEffect(() => {
    const width = window.innerWidth;

    const options = {
      rewind: true,
      perMove: 1,
      pagination: false,
      gap: "1rem",
      breakpoints: {
        1800:{perPage:4},
        1200: { perPage: 3 }, // tablets
        768: { perPage: 2 },  // mobiles
      },
    };

    // Set perPage for desktop if width > 1200
    if (width > 1200) {
      options.perPage = 4;
    }

    setSplideOptions(options);
  }, []);

  return splideOptions;
};

export default useResponsiveSplideOptions;
